// extracted by mini-css-extract-plugin
export default {"brand":"Header_brand__2z1-v","navList":"Header_navList__dhkDJ","navItem":"Header_navItem__QCrnK","navLink":"Header_navLink__rXJlR","navLinkActive":"Header_navLinkActive__8-1ef"};